import { SearchCriteria } from "./search-criteria";

export class SavePictureSearchCriteria extends SearchCriteria {

    public PictureFolder: string;
    public PictureName: string;
    public PicturePath: string;
}
